import { useParams } from "@tanstack/react-router"

export const useCommunityId = (): number | undefined => {
  try {
    const params = useParams({ strict: false })
    if (params.communityId) {
      const id = parseInt(params.communityId, 10)
      return isNaN(id) ? undefined : id
    }
  } catch {
    // Fall through to URL parsing
  }
  const match = window.location.pathname.match(/\/community\/(\d+)/)
  if (!match) return undefined
  const id = parseInt(match[1], 10)
  return isNaN(id) ? undefined : id
}
